(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var openBtns = document.querySelectorAll('[data-aura-menu-open]');
    var closeBtn = document.querySelector('[data-aura-menu-close]');
    var overlay = document.querySelector('[data-aura-menu-overlay]');
    var panel = document.querySelector('[data-aura-menu-panel]');
    var body = document.body;

    if (!panel || !overlay) return;

    function openMenu() {
      body.classList.add('aura-menu-open');
      panel.setAttribute('aria-hidden', 'false');
      openBtns.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'true');
      });
      // move focus into the panel for accessibility
      var firstLink = panel.querySelector('a');
      if (firstLink) firstLink.focus({ preventScroll: true });
    }

    function closeMenu() {
      body.classList.remove('aura-menu-open');
      panel.setAttribute('aria-hidden', 'true');
      openBtns.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', openMenu);
    });
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    overlay.addEventListener('click', closeMenu);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && body.classList.contains('aura-menu-open')) {
        closeMenu();
      }
    });

    // Close menu if window is resized past desktop breakpoint
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 900 && body.classList.contains('aura-menu-open')) {
        closeMenu();
      }
    });
  });
})();
